import { c as _c } from "react/compiler-runtime";
import { Status } from '@systemeio/components';
import { CalendarIcon } from '@systemeio/icons';
import { FunnelTabCard } from 'modules/funnels/funnel/components/funnel-tab-card';
import type { SplitTestHistoryTableInterface } from 'modules/funnels/funnel/types/funnel-tests-interface';
import type { ReactElement, ReactNode } from 'react';
import TransLoco from 'shared/components/trans-loco';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
interface SplitTestPeriodProps {
  action?: ReactNode;
  splitTest: Pick<SplitTestHistoryTableInterface['splitTest'], 'finishedAt' | 'startedAt'>;
}
export function SplitTestPeriod(t0) {
  const $ = _c(15);
  const {
    action,
    splitTest
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    intlLocale,
    user
  } = useUser();
  let period;
  if ($[0] !== intlLocale || $[1] !== splitTest.finishedAt || $[2] !== splitTest.startedAt || $[3] !== t || $[4] !== user?.timezone) {
    const formatter = new Intl.DateTimeFormat(intlLocale, {
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      month: "2-digit",
      timeZone: user?.timezone,
      year: "numeric"
    });
    period = {
      dateEnd: splitTest.finishedAt ? <span>{formatter.format(new Date(splitTest.finishedAt))}</span> : <Status color="active">{t("dashboard.funnel.split_tests.in_progress")}</Status>
    };
    if (splitTest.startedAt) {
      period.dateStart = <span>{formatter.format(new Date(splitTest.startedAt))}</span>;
    }
    $[0] = intlLocale;
    $[1] = splitTest.finishedAt;
    $[2] = splitTest.startedAt;
    $[3] = t;
    $[4] = user?.timezone;
    $[5] = period;
  } else {
    period = $[5];
  }
  let t1;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <CalendarIcon className="text-icon-secondary size-5 shrink-0" />;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== period || $[8] !== t) {
    t2 = <div className="text-text-secondary tablet:text-base flex min-w-0 items-center gap-3 text-sm">{t1}<span><TransLoco i18nKey="dashboard.funnel.split_tests.test_period" t={t} components={period} /></span></div>;
    $[7] = period;
    $[8] = t;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== action) {
    t3 = action && <div className="flex shrink-0 items-center gap-2">{action}</div>;
    $[10] = action;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== t2 || $[13] !== t3) {
    t4 = <FunnelTabCard className="flex items-center justify-between gap-4">{t2}{t3}</FunnelTabCard>;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
}